import React, { useEffect, useState } from 'react';
import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { useNavigate } from 'react-router-dom';
import {
  PREMATTER_ID_COOKIE,
  COLLECT_PHONE_NUMBER_COOKIE,
} from '../../constants';
import { actions } from '../../redux/slices';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import selectors from '../../redux/selectors';
import { AuthCallbackWrapper } from './wrapper';
import { TERMS_ACCEPTED_ID } from '@law-connect/react-components';
import { ConnectionIntentOptions } from '@law-connect/types';
import { PrematterType } from '@law-connect/types';
const Redirect: React.FC<{ path: string }> = ({ path }) => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(path);
  }, [navigate, path]);
  return null;
};

export const AuthCallbackComponent: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isLoading, isAuthenticated, user: kindeUser } = useKindeAuth();

  const [sessionPrematterId] = useState(
    window.sessionStorage.getItem(PREMATTER_ID_COOKIE)
  );

  const prematter = useAppSelector(selectors.session.getPrematter());

  const [collectPhoneNumber] = useState(
    window.sessionStorage.getItem(COLLECT_PHONE_NUMBER_COOKIE)
  );
  const [prefillTerms, setPrefillTerms] = useState(false);

  // The user is fetched earlier in the app
  const user = useAppSelector(selectors.user.getUser());

  useEffect(() => {
    dispatch(actions.session.fetch());
  }, [dispatch]);

  useEffect(() => {
    if (kindeUser?.email) {
      // These are read by GTM
      window.sessionStorage.setItem('lc_email', kindeUser.email);
      window.sessionStorage.setItem('lc_user_id', kindeUser.id);
      window.sessionStorage.setItem('lc_first_name', kindeUser.given_name);
      window.sessionStorage.setItem('lc_last_name', kindeUser.family_name);
    }
  }, [kindeUser]);

  useEffect(() => {
    const fetchPrematter = async () => {
      if (sessionPrematterId) {
        window.sessionStorage.setItem('lc_prematter_id', sessionPrematterId);
        const prematter = await dispatch(
          actions.prematter.fetchById({ id: sessionPrematterId })
        ).unwrap();
        if (prematter) {
          window.sessionStorage.setItem('lc_prematter_id', prematter.id);
          if (prematter.context.matterTypes?.length) {
            window.sessionStorage.setItem(
              'lc_matter_type',
              prematter.context.matterTypes[0].name
            );
          }
          if (prematter?.type === PrematterType.LawyerConnection) {
            window.sessionStorage.setItem(
              'quote_for_lawyer',
              ConnectionIntentOptions.ReadyToHire
            );
          }
        }
      }
    };
    fetchPrematter();
  }, [sessionPrematterId, dispatch]);

  useEffect(() => {
    if (prematter?.id) {
      console.log('prematter', prematter);
      // these are read by GTM
      window.sessionStorage.setItem('lc_prematter_id', prematter.id);
      if (prematter.context.matterTypes?.length) {
        window.sessionStorage.setItem(
          'lc_matter_type',
          prematter.context.matterTypes[0].name
        );
      }

      // We set this for GTM to track the quote for lawyer intent
      if (prematter?.type === PrematterType.LawyerConnection) {
        window.sessionStorage.setItem(
          'quote_for_lawyer',
          ConnectionIntentOptions.ReadyToHire
        );
      }
    }
  }, [prematter]);

  useEffect(() => {
    // if storgage window terms accepted, we want to update the users terms and privacy accepted
    if (window.localStorage.getItem(TERMS_ACCEPTED_ID)) {
      setPrefillTerms(true);
      window.localStorage.removeItem(TERMS_ACCEPTED_ID);
    }
  }, [dispatch]);

  useEffect(() => {
    if (sessionPrematterId) {
      dispatch(actions.session.delete());
    }
  }, [dispatch, sessionPrematterId]);

  if (isLoading) {
    return null;
  }

  if (
    (collectPhoneNumber && !user?.phone?.length) ||
    !user.termsAndPrivacyAccepted
  ) {
    return (
      <AuthCallbackWrapper
        showMobile={collectPhoneNumber && !user?.phone?.length}
        showTerms={!user.termsAndPrivacyAccepted}
        prefillTerms={prefillTerms}
      />
    );
  }

  if (sessionPrematterId) {
    return <Redirect path={`/case/${sessionPrematterId}`} />;
  }

  if (isAuthenticated) {
    return <Redirect path='/account' />;
  }

  return <Redirect path='/' />;
};
